<!--====== TEAM PART START ======-->

<section id="order" class="team-area pt-80 pb-130 gray-bg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6">
                <div class="section-title text-center pb-20">
                    <h5 class="mb-15">How to Order</h5>
                    <h2 class="title">Dealing In Second</h2>
                </div>
                <!-- section title -->
            </div>
        </div>

        <div class="row mt-20 text-center">
            <div data-aos="fade-left" class="col-lg-6 padding-0 text-right">
                <img
                    class="img-fluid"
                    src="/assets/images/orderone.jpeg"
                    alt="..."
                />
            </div>
            <div
                data-aos="fade-right"
                class="col-lg-6 order-lg-first padding-0"
            >
                <div class="h-100">
                    <div class="d-flex h-100">
                        <div class="project-text w-100">
                            <div>
                                <div class="count">01</div>
                                <a
                                    class="text-line mt-25 wow fadeInUp"
                                    data-wow-duration="1.5s"
                                    data-wow-delay="1s"
                                    href="#contact">Get Started</a
                                >
                            </div>
                            <h1 class="text-white">Kindly contact us</h1>
                            <p class="mb-0 mt-2 text-white-50">
                                Please kindly contact us by sending your inquiry
                                through email to coconusakhatulistiwa@gmail.com or our social media
                                to placing the order.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row text-center">
            <div data-aos="fade-left" class="col-lg-6 padding-0 text-right">
                <img
                    class="img-fluid"
                    src="/assets/images/ordertwo.jpeg"
                    alt="..."
                />
            </div>
            <div
                data-aos="fade-right"
                class="col-lg-6 padding-0"
            >
                <div class="h-100">
                    <div class="d-flex h-100">
                        <div class="project-text w-100 mt-100">
                            <div>
                                <div class="count">02</div>
                                <a
                                    class="text-line mt-25 wow fadeInUp"
                                    data-wow-duration="1.5s"
                                    data-wow-delay="1s"
                                    href="#contact">Find your commodity</a
                                >
                            </div>
                            <h1 class="text-white">Best Pricing</h1>
                            <p class="mb-0 mt-2 text-white-50">
                                Dealing with the sales contract.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row text-center">
            <div data-aos="fade-left" class="col-lg-6 padding-0 text-right">
                <img
                    class="img-fluid"
                    src="/assets/images/orderthree.jpeg"
                    alt="..."
                />
            </div>
            <div
                data-aos="fade-right"
                class="col-lg-6 order-lg-first padding-0"
            >
                <div class="h-100">
                    <div class="d-flex h-100">
                        <div class="project-text w-100">
                            <div>
                                <div class="count">03</div>
                                <a
                                    class="text-line wow fadeInUp mt-50"
                                    data-wow-duration="1.5s"
                                    data-wow-delay="1s"
                                    href="#contact">Here we go</a
                                >
                            </div>
                            <h1 class="text-white">Safely delivered</h1>
                            <p class="mb-0 mt-2 text-white-50">
                                After dealing, we will process your order and make sure that your order will be delivered with safe, according quality and on schedule.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <!-- container -->
</section>

<!--====== TEAM PART ENDS ======-->
<style>
    #order{
        max-width: 100%;
    }
    .order-lg-first {
        order: -1 !important;
    }
    .padding-0 {
        padding-left: 0;
        padding-right: 0;
    }

    .text-line {
        position: relative;
        font-size: x-large;
        font-weight: 500;
        font-family: "Barlow", sans-serif;
        color: #71bf43;
        text-transform: uppercase;
        margin-left: 0px;
        margin-top: 70px;
        letter-spacing: 2px;
    }

    .text-line::before {
        position: absolute;
        content: "";
        width: 60px;
        height: 2px;
        background-color: #71bf43;
        left: -70px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .count {
        position: absolute;
        left: 50px;
        bottom: 150px;
        z-index: -1;
        opacity: 0.2;
        font-size: 200px;
        line-height: 100%;
        font-weight: 700;
    }

    h1 {
        text-align: left;
        margin-left: 80px;
        margin-top: 15px;
    }
    p {
        text-align: left;
        margin-left: 80px;
        font-weight: 400;
        font-size: x-large;
    }
    .row {
        margin-top: 100px;
    }
    #order{
        background-color: #01264C;
    }
    .title{
        color: #fff;
    }
    h5 {
  
        font-size: 18px;
        color: #71bf43;
        text-transform: uppercase; 
    }

  @media (max-width: 767px) {
        h5 {
        font-size: 16px; 
        }
    }

    @media (max-width: 991.98px) {
        
    }

    /* Extra small devices (phones, 576px and down) */
    @media (max-width: 575.98px) {
        
        .count {
        position: absolute;
        top: 0px;
        left: 50px;
        bottom: 0px;
        z-index: -1;
        opacity: 0.2;
        font-size: 200px;
        line-height: 100%;
        font-weight: 700;
    }
    
        .text-line {
        position: relative;
        font-size: x-large;
        font-weight: 500;
        font-family: "Barlow", sans-serif;
        color: #71bf43;
        text-transform: uppercase;
        left: 0px;
        top: 0px;
        letter-spacing: 2px;
    }
        /* CSS rules for extra small devices */
    }

    /* Small devices (landscape phones, 576px and up) */
    @media (min-width: 576px) and (max-width: 767.98px) {
        
        /* CSS rules for small devices */
    }

    /* Medium devices (tablets, 768px and up) */
    @media (min-width: 768px) and (max-width: 991.98px) {
        /* CSS rules for medium devices */
    }
</style>
